import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { readStoredLanguage } from '../lib/languagePref'

/**
 * Every namespace, both languages, bundled statically (no HTTP backend,
 * `import.meta.glob` with `eager: true`) — so `init()` finishes synchronously
 * (`initImmediate: false`) and a page's very first render, including the
 * `renderToString` smoke tests, already has the right strings. Adding a
 * namespace means dropping `<name>.json` into both `locales/fa/` and
 * `locales/en/`; nothing here needs to change.
 */
const faModules = import.meta.glob('./locales/fa/*.json', { eager: true })
const enModules = import.meta.glob('./locales/en/*.json', { eager: true })

function toNamespaceResources(modules) {
  const namespaces = {}
  for (const [path, mod] of Object.entries(modules)) {
    const name = path.slice(path.lastIndexOf('/') + 1).replace(/\.json$/, '')
    namespaces[name] = mod.default ?? mod
  }
  return namespaces
}

const resources = {
  fa: toNamespaceResources(faModules),
  en: toNamespaceResources(enModules),
}

void i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: readStoredLanguage(),
    fallbackLng: 'fa',
    ns: Object.keys(resources.fa),
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    initImmediate: false,
    react: { useSuspense: false },
  })

/** Iran's rule is RTL/fa; English is the only locale this app ever renders LTR. */
function applyDocumentDirection(language) {
  if (typeof document === 'undefined') return
  document.documentElement.lang = language
  document.documentElement.dir = language === 'en' ? 'ltr' : 'rtl'
}

i18next.on('languageChanged', applyDocumentDirection)
applyDocumentDirection(i18next.language)

export default i18next
